import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ChestionarPublicPage from './public/ChestionarPublicPage'
import LinkUsedPage from './public/LinkUsedPage'
import SuccessPage from './public/SuccessPage'
import ShortLinkRedirectPage from './public/ShortLinkRedirectPage'
import ChestionarAngajatPage from './public/ChestionarAngajatPage'

export default function App() {
  return (
    <Router>
      <div className="min-h-screen w-full bg-background text-foreground">
        <Routes>
          <Route path="/questionar" element={<ChestionarPublicPage />} />
          {/* Staff questionnaire. Separate route and separate page: the token
              is resolved against the employee tables, and nothing about the
              patient flow applies to it. */}
          <Route path="/angajat/:token" element={<ChestionarAngajatPage />} />
          <Route path="/link-used" element={<LinkUsedPage />} />
          <Route path="/s/:code" element={<ShortLinkRedirectPage />} />
          {/* DEV ONLY: Success page preview route - REMOVE BEFORE PRODUCTION */}
          <Route path="/success-preview" element={
            <SuccessPage
              hospitalName="Spitalul Clinic Municipal de Urgenţă Timişoara"
              logoUrl="https://nqvqbdivdwkrennabmkd.supabase.co/storage/v1/object/public/hospital-branding/logos/f5d52420-304e-4147-bd6a-0f92957eb55b/scmt_logo.png"
            />
          } />
          <Route path="/" element={<Navigate to="/questionar?token=demo-token" replace />} />
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center text-center p-8">
              <div>
                <h1 className="text-2xl font-bold text-red-600 mb-4">Link Invalid</h1>
                <p className="text-gray-600">
                  Linkul nu este valid sau este incomplet. Vă rugăm să verificați URL-ul.
                </p>
              </div>
            </div>
          } />
        </Routes>
      </div>
    </Router>
  )
}